import React from "react";
import { useLocation } from "react-router-dom";
import EventGrid from "./EventGrid";

const EventListingPage = () => {
  const location = useLocation();

  const events = location.state?.events || [];
  const title = location.state?.title || "Events";

  return (
    <div className="max-w-7xl mx-auto py-8">
      <EventGrid
        title={title}
        events={events}
        showViewAll={false}
      />
    </div>
  );
};

export default EventListingPage;